import { useState } from 'react';
import axios from 'axios';
import { UploadSimple } from '@phosphor-icons/react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PlanPdfUploadDialog({ chantierId, batiments, onUploaded, onClose }) {
  const [nom, setNom] = useState('');
  const [batimentId, setBatimentId] = useState('');
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const submit = async () => {
    if (!file) { toast.error('Sélectionnez un PDF'); return; }
    if (!nom.trim()) { toast.error('Donnez un nom au plan'); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('nom', nom.trim());
      fd.append('file', file);
      if (batimentId) fd.append('batiment_id', batimentId);
      await axios.post(`${API_URL}/api/chantiers/${chantierId}/plans/upload-pdf`, fd, {
        withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Plan PDF importé');
      onUploaded();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur upload');
    } finally { setUploading(false); }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-md" data-testid="plan-pdf-upload-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'DM Serif Display, serif' }}>Importer un plan PDF</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Nom *</Label>
            <Input value={nom} onChange={e => setNom(e.target.value)}
              placeholder="Plan RDC, Plan masse…" className="rounded-none mt-1" autoFocus
              data-testid="plan-pdf-nom" />
          </div>
          <div>
            <Label className="text-xs">Bâtiment (optionnel)</Label>
            <select value={batimentId} onChange={e => setBatimentId(e.target.value)}
              className="w-full mt-1 p-2 border border-[#E0E0DB] text-sm rounded-none"
              data-testid="plan-pdf-batiment">
              <option value="">— Aucun bâtiment —</option>
              {batiments.map(b => <option key={b.id} value={b.id}>{b.nom}</option>)}
            </select>
          </div>
          <div>
            <Label className="text-xs">Fichier PDF *</Label>
            <input type="file" accept="application/pdf"
              onChange={e => {
                const f = e.target.files?.[0] || null;
                setFile(f);
                if (f && !nom) setNom(f.name.replace(/\.pdf$/i, ''));
              }}
              className="w-full mt-1 text-xs" data-testid="plan-pdf-file" />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={onClose} className="rounded-none">Annuler</Button>
            <Button onClick={submit} disabled={uploading || !file || !nom.trim()}
              className="bg-[#C75B39] hover:bg-[#D97B5C] rounded-none gap-2"
              data-testid="plan-pdf-submit">
              <UploadSimple size={14} /> Importer
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
